<template>
  <a-entity position="-.028 0 .001" @loaded="init">
      <a-plane
        transparent="true"
        opacity="1"
        ref="line"
        :width="line.w"
        :height="line.h"
        material="shader: flat; depthTest: false"
      />
      <a-plane
        color="#fff"
        opacity=".5"
        material="shader: flat; depthTest: false"
        :width="line.w"
        :height="line.h"
      />
      <a-ring ref="circle_left" color="#fff" material="shader: flat; depthTest: false" transparent="true" radius-inner=".005" radius-outer=".008"/>
      <a-circle ref="circle_right" color="#fff" material="shader: flat; depthTest: false" transparent="true" radius=".008" />
      <a-entity ref="play_pause_holder">
        <PlayPause ref="play_pause" v-if="!$root.$agent.mobile && !vr" />
      </a-entity>
      <a-entity ref="skip_holder">
        <Skip ref="skip" v-if="!$root.$agent.mobile && !vr" />
      </a-entity>
    <a-text
      ref="text" :value="time" width=".35"
      @materialtextureloaded="fixDepthText"
      :font-image="font.image"
      :font="font.fnt"
    />
  </a-entity>
</template>

<script>
import Moment from 'moment'
import Skip from '@/components/skip/Skip'
import PlayPause from '@/components/play_pause/PlayPause'
import { webkit } from './Howler'
import Settings from '@/config/Settings'

export default {
  name: 'Timeline',
  props: ['id', 'musicKey', 'name', 'sprite'],
  components: { Skip, PlayPause },
  beforeDestroy() {
    if(this.$rafId) {
      cancelAnimationFrame(this.$rafId)
    }
  },
  watch: {
    musicKey: 'start',
    orientation: 'setSize',
    vr: 'setSize'
  },
  data: () => ({
    time: '0:00',
    line: { w: .45, h: .005 },
    duration: 0,
    seek: 0,
    progress: 0,
    canNext: true,
    offset: 0,
    margin: {
      circle: .005,
      text: .035,
      skip: .11,
      play_pause: .055
    }
  }),
  created() {
    this.font = {
      image: require('@/commons/fonts/fonts/Exo2Bold.png'),
      fnt: require('@/commons/fonts/fonts/Exo2Bold.fnt')
    }

    if(Settings.localAssets)
      this.font = { image: null, fnt: null }
  },
  methods: {
    fixDepthText(e) {
      e.target.object3DMap.text.material.depthTest = false
    },
    setSize() {
      this.circle = .005
      this.text = .035
      this.skip = .11
      this.play_pause = .055
      this.$el.object3D.position.x = -.028
      this.line.w = .45

      if(this.$root.$agent.mobile && !this.vr) {
        this.margin.text = .025
        this.margin.skip = .085
        this.$el.object3D.position.x = -.023
        this.line.w = this.orientation == 'landscape' ? .4 : .23
      }

      TweenLite.set(this.$refs.circle_left, { aframe: { x: -this.line.w / 2 - this.margin.circle }})
      TweenLite.set(this.$refs.circle_right, { aframe: { x: this.line.w / 2 + this.margin.circle }})
      TweenLite.set(this.$refs.text, { aframe: { x: this.line.w / 2 + this.margin.text, y: Settings.localAssets ? .001 : .002 }})
      TweenLite.set(this.$refs.skip_holder, { aframe: { x: this.line.w / 2 + this.margin.skip }})
      TweenLite.set(this.$refs.play_pause_holder, { aframe: { x: - this.line.w / 2 - this.margin.play_pause }})
    },
    init() {
      this.setSize()
      this.start()
      this.update()
    },
    start() {
      this.progress = 0
      this.seek = 0
      this.canNext = true

      this.$music = this.$parent.type == 'webkit' ? this.$parent.$musics['webkit'] : this.$parent.$musics[this.name]

      if(this.$parent.type == 'webkit') {
        const sprite = _.find(webkit[this.name], (m,k) => k == this.sprite)
        this.offset = sprite[0] / 1000
        this.duration = sprite[1] / 1000
      } else {
        this.offset = this.$music._sprite[this.sprite][0] / 1000
        this.duration = (this.$music._sprite[this.sprite][1] / 1000) - 1
      }
    },
    goToNext() {
      this.progress = 1

      if(this.name == 'ambiences') {
        if(this.$parent.type == 'webkit') {
          const sprite = _.find(webkit[this.name], (m,k) => k == this.sprite)
          this.$music.seek(sprite[0] / 1000)
          this.start()
        }
        return
      }

      if(this.canNext) {
        this.next()
        this.canNext = false
      }
    },
    update() {
      this.$rafId = requestAnimationFrame(this.update)

      if(this.progress >= 1)
        this.goToNext()

      if(this.sprite == 'FinBoucle')
        this.$parent.explorer.seek = this.$music.seek(this.id)

      this.seek = this.$music.seek(this.id) - this.offset
      this.progress = this.seek / this.duration

      if(this.progress < 0)
        return

      const temps_restant = {
        m: Math.abs(parseInt((this.seek - this.duration) / 60)),
        s: Math.abs(parseInt((this.seek - this.duration) % 60))
      }

      temps_restant.s = temps_restant.s < 10 ? '0' + temps_restant.s : temps_restant.s
      this.time = temps_restant.m + ':' + temps_restant.s

      if(this.$refs.line && this.name != 'ambiences') {
        const x = -(this.line.w / 2) + (this.progress * this.line.w - (this.progress * this.line.w / 2))
        TweenLite.set(this.$refs.line, { aframe: {scaleX: this.progress, x: x}})
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/music/Timeline.vue